<template>
  <div>
    <Loading v-if="showWait" />
    <div v-else>
      <PageTitle
        :main="`Projeção do Consumo de Insumos`"
        sub=""
        imagem="storage.png"
      />
      <MaterialInputPlanGrid></MaterialInputPlanGrid>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import MaterialInputPlanGrid from "./MaterialInputPlanGrid.vue";
import Loading from "@/components/template/Loading.vue"
import {mapState} from "vuex";

export default {
  name: "MaterialInputPlan",
  components: { MaterialInputPlanGrid, PageTitle, Loading },
  computed: mapState(["showWait"]),
  data() {
    return {
      imagem: "",
    };
  },
  watch: {
  },
  beforeCreate(){
    this.$store.commit("setShowWait", true);
  },
  mounted(){
    this.$store.commit("setShowWait", false);
  }
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
